import styled from 'styled-components'

const Wrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  margin: 3rem 0 1rem;
`
const MetaData = ({ id, date }) => {
  return (
    <Wrapper>
      {date && <span>Last update: {new Date(date).toDateString()}</span>}
      {id && <span>Article ID: {id}</span>}
    </Wrapper>
  )
}

export default MetaData
